"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _confirmWithdrawActions = require("../../redux/actions/confirmWithdrawActions");
var _queryParamsHelper = require("../../helpers/queryParamsHelper");
var _VerifyDeviceComponent = _interopRequireDefault(require("./VerifyDeviceComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var processingVerifyDevice = state.apiProcessing.processingVerifyDevice,
    _state$verifyDevice = state.verifyDevice,
    message = _state$verifyDevice.message,
    error = _state$verifyDevice.error;
  return {
    processingVerifyDevice: processingVerifyDevice,
    message: message,
    error: error
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var d1 = (0, _queryParamsHelper.getQueryParam)('d1');
  var hashCode = (0, _queryParamsHelper.getQueryParam)('HashCode');
  var UserId = (0, _queryParamsHelper.getQueryParam)('UserId');
  var verifycode = (0, _queryParamsHelper.getQueryParam)('verifycode');
  return {
    verifyDevice: function verifyDevice() {
      return dispatch((0, _confirmWithdrawActions.verifyDevice)({
        verifycode: verifycode,
        UserId: UserId,
        d1: d1,
        hashCode: hashCode
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_VerifyDeviceComponent["default"]);